import axios from 'axios';

const apiCep = axios.create({
  baseURL: 'https://viacep.com.br/ws',
});

export const apiIBGE = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v1/localidades',
});

export default apiCep;
